import { useCustomizerSpace } from '../hooks/index.js'
import { SlateEditor, SlateTree } from '../SlateEditor/index.js'

export const SpaceSidebarEditor = () => {
  const { space } = useCustomizerSpace()

  if (!space?.slate) {
    return null
  }

  return (
    <SlateEditor slates={[{ id: space.id, slate: space.slate }]}>
      <div className="-ms-3 -me-3">
        <SlateTree id={space.id} />
      </div>
    </SlateEditor>
  )
}
